<template>
    <v-container justify-center>
        <v-card>
            <v-card-title class="subheading grey--text text--darken-3">
                <IconBack @clicked="$router.go(-1)" /> &nbsp;
              
                {{report.id ? report.dataSet.name : 'Create New Report'}}
                <v-spacer/>
                <v-btn @click="submit" small  class="btnSave">Save</v-btn>
            </v-card-title>
            <v-card-text >
                <v-layout row wrap class="text-xs-left">
                    <v-flex xs3 v-if="!report.id" class="text-xs-left">
                        <b>Select Your Reports </b>
                        <v-btn icon class="pa-0 ma-0">
                            <svg  v-if="!report.id" 
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                @click="DatasetAdd()"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <title>Add DataSets</title>
                                <circle cx="11" cy="11" r="11" stroke="#3D56E6" />
                                <path
                                d="M10.9998 7.69922V15.3992"
                                stroke="#3D56E6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                />
                                <path
                                d="M14.8506 11.55L7.15059 11.55"
                                stroke="#3D56E6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                />
                            </svg>
                        </v-btn>
                        <!-- <v-icon title="Add DataSets" 
                        v-if="!report.id"
                        small flat class="black--text pt-0 pl-1" @click ="DatasetAdd()">fa fa-plus</v-icon> -->
                       
                        <v-select attach 
                            class="style-input mr-2 pa-0 ma-0"
                            v-if="!report.id"
                            item-text="name"
                            outline
                            height="10px"
                            single-line
                            hide-details
                            item-value="id"
                            return-object
                            @input="getColumns"
                            v-model="dataSet"
                            :items="dataSets"
                        />
                        <span v-if="report.id"  class="subheading body-2 "> 
                            <br/>
                            <strong>{{report.data_sets.name}}</strong>
                        </span>
                    </v-flex>
                    <!-- <v-flex sm1>
                        <v-icon title="Add" small flat class="blue--text" @click ="DatasetAdd()">fa fa-plus</v-icon>
                    </v-flex> -->
                    <v-flex :xs11="report.id" :xs9="!dataSet.id" :xs8="!report.id" :pl-2="!report.id" class="text-xs-left pt-2">
                        <b>Name of the Report</b> <br/><br/>
                        <v-text-field
                            outline
                            class="style-input mr-2 pt-1"
                            v-model="report.name"
                            single-line
                            hide-details
                            height="25px"
                        />
                    </v-flex>
                    <v-flex v-if="dataSet.id || report.id" xs1><br/><br/>
                        <v-btn @click="showAdvancedCode()" style="zoom:80%" small class="btnSave mt-3">Advanced</v-btn>
                    </v-flex>
                    <v-flex xs12 class="pt-1" style="background:#f1f1f1">
                        <ReportDesigner
                         v-if="Object.keys(reportColumns).length>0"
                         :value="reportColumns" 
                         :reportLayout="layout"
                        :reportFilters="reportFilters"
                        :reportSort ="sort"
                        :reportGroup ="groupBy"
                        v-on:refreshDataSet="refreshDataSet"
                         v-on:layoutChanged="layoutChanged" />
                    </v-flex>
                    <v-flex xs12>
                <v-card v-if="showAdvanced">
                <v-card-text>
        <v-layout>
          <v-flex xs6 mr-2>
            <v-flex xs2 class="pt-3">
              <b>After Render</b>
            </v-flex>
            <v-flex xs10 class="text-xs-right pa-0">
              <v-radio-group
                height="5px"
                sytle="padding-top:1px;padding-bottom:1px;margin:0px"
                row
                v-model="render.after_render.codeType"
              >
                <v-radio value="js">
                  <div slot="label">Javascript</div>
                </v-radio>
                <v-radio value="sql">
                  <div slot="label">SQL</div>
                </v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                class="style-input mr-2"
                v-validate="'required'"
                data-vv-name="code"
                outline
                rows="5"
                hide-details
                :error-messages="errors.collect('code')"
                v-model="render.after_render.code"
                required
              />
            </v-flex>
          </v-flex>
          <v-flex xs6>
            <v-flex xs3 class="pt-3">
              <b>Before Render</b>
            </v-flex>
            <v-flex xs10 class="text-xs-right pa-0">
              <v-radio-group
                height="5px"
                sytle="padding-top:1px;padding-bottom:1px;margin:0px"
                row
                v-model="render.before_render.codeType"
              >
                <v-radio value="js">
                  <div slot="label">Javascript</div>
                </v-radio>
                <v-radio value="sql">
                  <div slot="label">SQL</div>
                </v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                class="style-input mr-2"
                v-validate="'required'"
                data-vv-name="code"
                outline
                rows="5"
                hide-details
                :error-messages="errors.collect('render')"
                v-model="render.before_render.code"
                required
              />
            </v-flex>
          </v-flex>
            </v-layout>

                </v-card-text>
            </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-dialog v-model="entryModal" 
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
                max-width="600px">
                <DataSetEdit v-if="editFlag" :parameters ="editData" v-on:closeDialog="closeDialog1"/>
            </v-dialog>
        </v-card>
    </v-container>
</template>
<script>
import lodash from 'lodash'
import DataSetModel from '@/api/service/DataSetService.js'
import DataSetEdit from '@/views/dataSets/template/edit.vue'
import ReportDesigner from './ReportDesigner.vue'
import ReportModel from '../../service/ReportService.js'
import IconBack from '@/components/Icons/IconBack.vue'
export default {
    components: {
        ReportDesigner,
        DataSetEdit,
        IconBack
    },
    data() {
        return {
            dataSet:{},
            report_name:"",
            dataSets:[],
            showAdvanced:false,
            entryModal:false,
            editFlag:false,
            editData:{},
            reportColumns:[],
            reportFilters:[],
            filters:{},
            report:{
               
            },
            render:{
                 before_render:{
                    code:"", codeType:"js"},
                after_render:{
                    code:"", codeType:"js"}
            },
            layout:{},
            sort:{},
            groupBy:{}
        }
    },
    created:async function() {
         await this.getDataSets()
        if(this.$route.query.id) {
            this.getReport(this.$route.query.id)
        }
       
    },
    methods: {
        getReport($id) {
            ReportModel.getReports({"id":$id})
            .then($reports => {
                this.report = $reports[0]
                let $ds =  lodash.filter(this.dataSets,{"id":this.report.data_set_id})
                this.report.dataSet = $ds && $ds.length>0 ? $ds[0] : {}
                this.reportColumns =this.report.columns ? JSON.parse(this.report.columns): {}
                this.reportFilters = JSON.parse(this.report.filters)
                console.log(this.report.layout)
               let $layout = this.report.layout ? JSON.parse(this.report.layout) : Object.keys(this.reportColumns)
                this.sort = JSON.parse(this.report.sort)
                this.groupBy = this.report.group_by ? JSON.parse(this.report.group_by) :{}
                for(let $i=0;$i<$layout.length;$i++) {
                    this.layout[$layout[$i]]= this.reportColumns[$layout[$i]]
                } 
                this.render.before_render = this.report.before_render ? JSON.parse(this.report.before_render) : this.render.before_render
                this.render.after_render = this.report.after_render ? JSON.parse(this.report.after_render) : this.render.after_render
                if(this.render.before_render.code || this.render.after_render.code){
                    this.showAdvanced =true
                } else{
                    this.showAdvanced =false
                }
                this.$forceUpdate() 
                //this.reportColumns = Object.assign({},this.report.columns)
                //this.reportFilters = Object.assign({},this.report.filters)
                
            })
        },
        async getDataSets() {
            try {
             this.dataSets = await DataSetModel.findAll({type:"R"})
            } catch(exception) {

            }
        },
        refreshDataSet($sort,$layout,$filters,$groupBy) {
            this.layout = $layout
            this.sort = $sort
            this.groupBy = $groupBy
            this.filters = $filters
            //alert('here')
            this.getColumns()
        },
        refreshColumns($report,$columns) {
            let $keys= Object.keys($columns[0].column)
           // alert(JSON.stringify($keys,null,4))
            let $reportColumns = Object.assign({},this.reportColumns)
            for(let $i=0;$i<$keys.length;$i++) {
             //   alert($keys[$i])
                if(!$reportColumns[$keys[$i]]) {
                    //alert($keys[$i])
                    $reportColumns[$keys[$i]]=$columns[0].column[$keys[$i]]
                }
            }
            this.report = Object.assign({},$report)
            this.reportColumns= Object.assign({},$reportColumns)
            console.log(JSON.stringify($reportColumns,null,4))
            this.$forceUpdate()
        },
        async getColumns()
        {
            if(this.report.id) {
                let $report = Object.assign({},this.report)
                let $columns = await DataSetModel.getColumnsForReport(this.report.data_sets)
                this.report ={}
                $report[0].before_render={code:"", codeType:"js"}
                $report[0].after_render={code:"", codeType:"js"}
                this.refreshColumns($report,$columns)

            } else {
                this.report = await DataSetModel.getColumnsForReport(this.dataSet)
                //alert(JSON.stringify(this.report[0].column,null,4))
                this.reportColumns = this.report[0].column
                
                this.reportFilters = this.report[0].filter
            }
             
        },
        layoutChanged($sort,$layout,$filters,$groupBy) {
            this.layout = $layout
            this.sort = $sort
            this.groupBy = $groupBy
            this.filters = $filters
        },
        closeDialog1() {
            this.entryModal=false
            this.editFlag=false
            this.getDataSets()
        },
        DatasetAdd()
        {
           this.entryModal = true
           this.editFlag = true
           this.editData = {}
        },
        showAdvancedCode(){
            // if(!this.report.id){
            //     if(!this.report[0].before_render){
            //         this.report[0].before_render ={codeType:"js", code:""}
            //     }
            //     if(!this.report[0].after_render){
            //         this.report[0].after_render ={codeType:"js", code:""}
            //     }
            // } else{
            //      if(!this.report.before_render){
            //         this.report.before_render ={codeType:"js", code:""}
            //     }
            //     if(!this.report.after_render){
            //         this.report.after_render ={codeType:"js", code:""}
            //     }
            // }
            this.showAdvanced=true
            this.$forceUpdate()
        },
        async submit() {
            let $reportData = {
                "name":this.report.name,
                "description":this.report.name,
                "url":this.dataSet.data_source,
                "data_source":this.dataSet.data_source,
                "action":"get",
                "columns":JSON.stringify(this.reportColumns),
                "layout":JSON.stringify(Object.keys(this.layout)),
                "sort":JSON.stringify(this.sort),
                "group_by":JSON.stringify(this.groupBy),
                "filters":JSON.stringify(this.filters),
                "active":1,
                "data_set_id":this.report.id ? this.report.dataSet.id : this.dataSet.id,
                "before_render": this.render.before_render ? JSON.stringify(this.render.before_render) : '{}',                
                "after_render": this.render.after_render ? JSON.stringify(this.render.after_render) : '{}'
            }
            try {
                if(this.report.id) {
                    $reportData.id = this.report.id 
                    await ReportModel.update($reportData)
                } else {
                    await ReportModel.create($reportData)
                }
                this.$router.push('/reports')
            } catch(error) {
                    console.log(error)
            }
        }
    }
}
</script>
<style>
.style-input {
    padding:0px;
    margin:0px;
}
</style>